export const ID_FILTER_SEARCH = "search";
export const ID_FILTER_MSTYPE = "mobility-store-type";
export const ID_FILTER_NAME = "name";
export const ID_FILTER_VALID_FROM = "valid-from";
export const ID_FILTER_VALID_TO = "valid-to";
export const ID_FILTER_STATUS = "status";
export const ID_FILTER_LEGAL_ENTITIES = "legal-entities";
export const ID_FILTER_DEALERS = "dealers";

export const clusterDefaultValues = {
    storeTypes: "",
    name: null,
    statuses: "",
    validFrom: null,
    validTo: null
}